import React from 'react';

import { useReactiveForm as useReactiveFormShared } from '@bcp-channels-sharedcomponents-reactjs/form-utils/dist/hooks';
import { UseReactiveFormInput } from '@bcp-channels-sharedcomponents-reactjs/form-utils/dist/types';

export const useReactiveForm = (props: UseReactiveFormInput) => {
	const reactiveForm = useReactiveFormShared(props);
	const inputStatus = React.useRef<Record<string, 'default' | 'focused' | 'blurred'>>({});

	const handleGetInputProps = React.useCallback(
		(name: string) => {
			const { error, onBlur, onChange, onFocus, value, showErrors } = reactiveForm.getInputProps(name);
			return {
				name,
				status: (showErrors && error ? 'error' : 'default') as 'error' | 'default',
				onChange,
				value,
				bottomMessage: {
					text: {
						content: showErrors && error ? error : '',
					},
				},
				debounce: 0,
				// onBlur: (blurred: boolean): void => {
				// 	if (blurred && inputStatus.current[name] !== 'blurred') {
				// 		inputStatus.current[name] = 'blurred';
				// 		onBlur();
				// 	}
				// },
				// onFocus: (focused: boolean): void => {
				// 	if (focused && inputStatus.current[name] !== 'focused') {
				// 		inputStatus.current[name] = 'focused';
				// 		onFocus();
				// 	}
				// },
				onBlur: (): void => {
					onBlur();
				},
				onFocus: (): void => {
					onFocus();
				},
				error,
			};
		},
		[reactiveForm]
	);

	return {
		...reactiveForm,
		getInputProps: handleGetInputProps,
	};
};
